// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/auth.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/auth.proto.
 */
export const file_cortado_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * GmailAccount represents a connected Gmail account
 *
 * @generated from message cortado.v1.GmailAccount
 */
export type GmailAccount = Message<"cortado.v1.GmailAccount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string selected_calendar_id = 7;
   */
  selectedCalendarId?: string;

  /**
   * @generated from field: optional string selected_calendar_name = 8;
   */
  selectedCalendarName?: string;

  /**
   * True when the stored refresh token has been revoked or expired and the
   * user must re-authenticate via the OAuth flow. Served from persisted
   * credential health; callers can request an explicit recheck.
   *
   * @generated from field: bool needs_reconnect = 9;
   */
  needsReconnect: boolean;

  /**
   * NEW: who linked this account (display only)
   *
   * "Ryan Hill" — best-effort display
   *
   * @generated from field: optional string linked_by_name = 10;
   */
  linkedByName?: string;

  /**
   * user.email if available
   *
   * @generated from field: optional string linked_by_email = 11;
   */
  linkedByEmail?: string;

  /**
   * Populated only when needs_reconnect is true. Mirrors the persisted
   * last_refresh_error_code (e.g. "invalid_grant", "insufficient_scopes").
   *
   * @generated from field: optional string reconnect_reason = 12;
   */
  reconnectReason?: string;
};

/**
 * Describes the message cortado.v1.GmailAccount.
 * Use `create(GmailAccountSchema)` to create a new message.
 */
export const GmailAccountSchema: GenMessage<GmailAccount> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 0);

/**
 * GetGmailAuthURL returns the OAuth URL for connecting Gmail
 *
 * @generated from message cortado.v1.GetGmailAuthURLRequest
 */
export type GetGmailAuthURLRequest = Message<"cortado.v1.GetGmailAuthURLRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * When set, the OAuth callback updates this existing Gmail credential instead
   * of creating a new account. Used to reconnect revoked/expired accounts.
   *
   * @generated from field: optional string gmail_account_id = 2;
   */
  gmailAccountId?: string;
};

/**
 * Describes the message cortado.v1.GetGmailAuthURLRequest.
 * Use `create(GetGmailAuthURLRequestSchema)` to create a new message.
 */
export const GetGmailAuthURLRequestSchema: GenMessage<GetGmailAuthURLRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 1);

/**
 * @generated from message cortado.v1.GetGmailAuthURLResponse
 */
export type GetGmailAuthURLResponse = Message<"cortado.v1.GetGmailAuthURLResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message cortado.v1.GetGmailAuthURLResponse.
 * Use `create(GetGmailAuthURLResponseSchema)` to create a new message.
 */
export const GetGmailAuthURLResponseSchema: GenMessage<GetGmailAuthURLResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 2);

/**
 * IsGmailConnected checks if Gmail is connected and returns accounts
 *
 * @generated from message cortado.v1.IsGmailConnectedRequest
 */
export type IsGmailConnectedRequest = Message<"cortado.v1.IsGmailConnectedRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.IsGmailConnectedRequest.
 * Use `create(IsGmailConnectedRequestSchema)` to create a new message.
 */
export const IsGmailConnectedRequestSchema: GenMessage<IsGmailConnectedRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 3);

/**
 * @generated from message cortado.v1.IsGmailConnectedResponse
 */
export type IsGmailConnectedResponse = Message<"cortado.v1.IsGmailConnectedResponse"> & {
  /**
   * @generated from field: bool is_connected = 1;
   */
  isConnected: boolean;

  /**
   * @generated from field: repeated cortado.v1.GmailAccount connected_emails = 2;
   */
  connectedEmails: GmailAccount[];

  /**
   * Top-level rollup: true if any of the connected accounts has a revoked or
   * expired refresh token. UI uses this to render a single "Reconnect Google"
   * banner without iterating per account.
   *
   * @generated from field: bool needs_reconnect = 3;
   */
  needsReconnect: boolean;
};

/**
 * Describes the message cortado.v1.IsGmailConnectedResponse.
 * Use `create(IsGmailConnectedResponseSchema)` to create a new message.
 */
export const IsGmailConnectedResponseSchema: GenMessage<IsGmailConnectedResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 4);

/**
 * RecheckGmailAccountHealth probes one Gmail account and persists its current health.
 *
 * @generated from message cortado.v1.RecheckGmailAccountHealthRequest
 */
export type RecheckGmailAccountHealthRequest = Message<"cortado.v1.RecheckGmailAccountHealthRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string gmail_account_id = 2;
   */
  gmailAccountId: string;
};

/**
 * Describes the message cortado.v1.RecheckGmailAccountHealthRequest.
 * Use `create(RecheckGmailAccountHealthRequestSchema)` to create a new message.
 */
export const RecheckGmailAccountHealthRequestSchema: GenMessage<RecheckGmailAccountHealthRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 5);

/**
 * @generated from message cortado.v1.RecheckGmailAccountHealthResponse
 */
export type RecheckGmailAccountHealthResponse = Message<"cortado.v1.RecheckGmailAccountHealthResponse"> & {
  /**
   * @generated from field: cortado.v1.GmailAccount account = 1;
   */
  account?: GmailAccount;

  /**
   * @generated from field: bool needs_reconnect = 2;
   */
  needsReconnect: boolean;
};

/**
 * Describes the message cortado.v1.RecheckGmailAccountHealthResponse.
 * Use `create(RecheckGmailAccountHealthResponseSchema)` to create a new message.
 */
export const RecheckGmailAccountHealthResponseSchema: GenMessage<RecheckGmailAccountHealthResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 6);

/**
 * UpdateGmailAccount updates a Gmail account (only is_default field)
 *
 * @generated from message cortado.v1.UpdateGmailAccountRequest
 */
export type UpdateGmailAccountRequest = Message<"cortado.v1.UpdateGmailAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional bool is_default = 2;
   */
  isDefault?: boolean;
};

/**
 * Describes the message cortado.v1.UpdateGmailAccountRequest.
 * Use `create(UpdateGmailAccountRequestSchema)` to create a new message.
 */
export const UpdateGmailAccountRequestSchema: GenMessage<UpdateGmailAccountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 7);

/**
 * @generated from message cortado.v1.UpdateGmailAccountResponse
 */
export type UpdateGmailAccountResponse = Message<"cortado.v1.UpdateGmailAccountResponse"> & {
  /**
   * @generated from field: cortado.v1.GmailAccount account = 1;
   */
  account?: GmailAccount;
};

/**
 * Describes the message cortado.v1.UpdateGmailAccountResponse.
 * Use `create(UpdateGmailAccountResponseSchema)` to create a new message.
 */
export const UpdateGmailAccountResponseSchema: GenMessage<UpdateGmailAccountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 8);

/**
 * DeleteGmailAccount disconnects a Gmail account
 *
 * @generated from message cortado.v1.DeleteGmailAccountRequest
 */
export type DeleteGmailAccountRequest = Message<"cortado.v1.DeleteGmailAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteGmailAccountRequest.
 * Use `create(DeleteGmailAccountRequestSchema)` to create a new message.
 */
export const DeleteGmailAccountRequestSchema: GenMessage<DeleteGmailAccountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 9);

/**
 * @generated from message cortado.v1.DeleteGmailAccountResponse
 */
export type DeleteGmailAccountResponse = Message<"cortado.v1.DeleteGmailAccountResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteGmailAccountResponse.
 * Use `create(DeleteGmailAccountResponseSchema)` to create a new message.
 */
export const DeleteGmailAccountResponseSchema: GenMessage<DeleteGmailAccountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 10);

/**
 * CheckEventsCalendarExists checks if the "Events" calendar exists in Google Calendar
 *
 * @generated from message cortado.v1.CheckEventsCalendarExistsRequest
 */
export type CheckEventsCalendarExistsRequest = Message<"cortado.v1.CheckEventsCalendarExistsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.CheckEventsCalendarExistsRequest.
 * Use `create(CheckEventsCalendarExistsRequestSchema)` to create a new message.
 */
export const CheckEventsCalendarExistsRequestSchema: GenMessage<CheckEventsCalendarExistsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 11);

/**
 * @generated from message cortado.v1.CheckEventsCalendarExistsResponse
 */
export type CheckEventsCalendarExistsResponse = Message<"cortado.v1.CheckEventsCalendarExistsResponse"> & {
  /**
   * @generated from field: bool exists = 1;
   */
  exists: boolean;

  /**
   * If found, the calendar ID
   *
   * @generated from field: string calendar_id = 2;
   */
  calendarId: string;

  /**
   * If not found or error occurred
   *
   * @generated from field: string error_message = 3;
   */
  errorMessage: string;
};

/**
 * Describes the message cortado.v1.CheckEventsCalendarExistsResponse.
 * Use `create(CheckEventsCalendarExistsResponseSchema)` to create a new message.
 */
export const CheckEventsCalendarExistsResponseSchema: GenMessage<CheckEventsCalendarExistsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 12);

/**
 * GoogleCalendar represents a calendar in Google Calendar
 *
 * @generated from message cortado.v1.GoogleCalendar
 */
export type GoogleCalendar = Message<"cortado.v1.GoogleCalendar"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string gmail_account_id = 3;
   */
  gmailAccountId: string;

  /**
   * @generated from field: string gmail_account_email = 4;
   */
  gmailAccountEmail: string;

  /**
   * Whether the connected credential can write events to this calendar
   * (accessRole owner|writer). Read-only calendars are non-writable.
   *
   * @generated from field: bool can_write = 5;
   */
  canWrite: boolean;
};

/**
 * Describes the message cortado.v1.GoogleCalendar.
 * Use `create(GoogleCalendarSchema)` to create a new message.
 */
export const GoogleCalendarSchema: GenMessage<GoogleCalendar> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 13);

/**
 * ListGoogleCalendars lists all calendars for connected Google accounts
 *
 * @generated from message cortado.v1.ListGoogleCalendarsRequest
 */
export type ListGoogleCalendarsRequest = Message<"cortado.v1.ListGoogleCalendarsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListGoogleCalendarsRequest.
 * Use `create(ListGoogleCalendarsRequestSchema)` to create a new message.
 */
export const ListGoogleCalendarsRequestSchema: GenMessage<ListGoogleCalendarsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 14);

/**
 * @generated from message cortado.v1.ListGoogleCalendarsResponse
 */
export type ListGoogleCalendarsResponse = Message<"cortado.v1.ListGoogleCalendarsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.GoogleCalendar calendars = 1;
   */
  calendars: GoogleCalendar[];

  /**
   * @generated from field: optional string selected_calendar_id = 2;
   */
  selectedCalendarId?: string;

  /**
   * @generated from field: optional string selected_calendar_name = 3;
   */
  selectedCalendarName?: string;

  /**
   * @generated from field: optional string selected_gmail_account_id = 4;
   */
  selectedGmailAccountId?: string;

  /**
   * @generated from field: optional string selected_gmail_account_email = 5;
   */
  selectedGmailAccountEmail?: string;
};

/**
 * Describes the message cortado.v1.ListGoogleCalendarsResponse.
 * Use `create(ListGoogleCalendarsResponseSchema)` to create a new message.
 */
export const ListGoogleCalendarsResponseSchema: GenMessage<ListGoogleCalendarsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 15);

/**
 * SetGoogleCalendar sets the calendar to use for event syncing
 *
 * @generated from message cortado.v1.SetGoogleCalendarRequest
 */
export type SetGoogleCalendarRequest = Message<"cortado.v1.SetGoogleCalendarRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string calendar_id = 2;
   */
  calendarId: string;

  /**
   * @generated from field: string calendar_name = 3;
   */
  calendarName: string;

  /**
   * @generated from field: string gmail_account_id = 4;
   */
  gmailAccountId: string;
};

/**
 * Describes the message cortado.v1.SetGoogleCalendarRequest.
 * Use `create(SetGoogleCalendarRequestSchema)` to create a new message.
 */
export const SetGoogleCalendarRequestSchema: GenMessage<SetGoogleCalendarRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 16);

/**
 * @generated from message cortado.v1.SetGoogleCalendarResponse
 */
export type SetGoogleCalendarResponse = Message<"cortado.v1.SetGoogleCalendarResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message cortado.v1.SetGoogleCalendarResponse.
 * Use `create(SetGoogleCalendarResponseSchema)` to create a new message.
 */
export const SetGoogleCalendarResponseSchema: GenMessage<SetGoogleCalendarResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_auth, 17);

